import { Grilla } from '../atomos';
import PieDePagina from '../organismos/PieDePagina';
import { Navigate } from 'react-router-dom';
import { CREDENCIALES } from '@/routes/AppRoutes';
import { useRutasProtegidas } from '@/hooks/useRutasProtegidas';
import BarraLateral from './BarraLateral';
import ContenedorPaginas from './ContenedorPaginas';
import { useAppSelector } from '@/hooks/redux';

const PlantillaFactoring = () => {
  const { token } = useRutasProtegidas();
  const { menu } = useAppSelector((state) => state.usuario);

  return (
    <>
      <Grilla
        templateColumns={"auto 1fr"}
        templateRows={'1fr'}
        minH={'100dvh'}
        minW={'full'}
        maxW={'full'}
      >
        <BarraLateral menu={menu} />

        {token ? (
          <ContenedorPaginas />
        ) : (
          <Navigate to={CREDENCIALES.INICIARSESION} />
        )}
      </Grilla>
      <PieDePagina />
    </>
  );
};

export default PlantillaFactoring;
